import NavigationPanel from './navigationPanel'

const navigationPanel = new NavigationPanel()
navigationPanel.init()
